import { DialogBox, StyledDialogActions } from './PauseMembersDialog.styles';
import {
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  ErrorIcon,
  MessageBanner,
  Stack,
  Typography,
  useTheme,
} from '@silverstein-properties/inspirelabs-ui';
import { useState } from 'react';
import { LoadingButton } from '@mui/lab';
import { MembershipPlanPurchase } from '@/types';

export interface PauseMembersDialogProps {
  open: boolean;
  membershipPlanPurchase: MembershipPlanPurchase;
  onConfirm: (isGracefulCancelation: boolean) => Promise<void> | void;
  onClose: () => Promise<void> | void;
  errorMessage?: string;
}

export default function PauseMembersDialog({
  open,
  membershipPlanPurchase,
  onConfirm,
  onClose,
  errorMessage,
}: PauseMembersDialogProps) {
  const [isLoadingButton, setLoadingButton] = useState(false);
  const theme = useTheme();

  const handleUserConfirmation = async () => {
    setLoadingButton(true);
    try {
      await onConfirm(!membershipPlanPurchase.pauseCollection);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingButton(false);
    }
  };
  return (
    <>
      <DialogBox
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        PaperProps={{
          sx: {
            width: '450px',
            maxWidth: '100%',
            maxHeight: '90%',
            height: 'auto',
          },
        }}
      >
        <Stack
          justifyContent="center"
          alignItems="center"
          alignSelf="center"
          marginTop={theme.spacers.l}
        >
          <ErrorIcon width={80} color={theme.palette.error.main} />
        </Stack>
        <DialogTitle id="alert-dialog-title">
          <Typography variant="h4">
            {membershipPlanPurchase.pauseCollection
              ? 'Resume membership?'
              : 'Pause membership?'}
          </Typography>
          <Stack sx={{ width: '100%' }}>
            <MessageBanner flexWrap="wrap" hidden={!errorMessage} type="error">
              {errorMessage}
            </MessageBanner>
          </Stack>
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <Typography color="primary">
              Clicking the "Confirm" button below will{' '}
              {membershipPlanPurchase.pauseCollection ? 'resume' : 'pause'} the
              memberships immediately.
            </Typography>
            <Stack
              sx={{
                marginTop: theme.spacers.l,
                marginBottom: theme.spacers.l,
                marginLeft: theme.spacers.l,
              }}
            >
              <Typography
                color="primary"
                variant="subtitle1"
                alignSelf="flex-start"
              >
                Members
              </Typography>
              <>
                {membershipPlanPurchase.planConsumers.map(consumer => (
                  <Typography key={consumer.id} alignSelf="flex-start">
                    {consumer.consumer?.firstName} {consumer.consumer?.lastName}{' '}
                    {consumer.consumerId ===
                    membershipPlanPurchase.primaryConsumerId
                      ? '(Primary)'
                      : ''}
                  </Typography>
                ))}
              </>
            </Stack>
          </DialogContentText>
        </DialogContent>
        <StyledDialogActions>
          <LoadingButton
            loading={isLoadingButton}
            variant="contained"
            size="large"
            onClick={handleUserConfirmation}
          >
            Confirm
          </LoadingButton>

          <Button
            variant="text"
            size="large"
            sx={{ marginTop: theme.spacers.l }}
            onClick={onClose}
          >
            Cancel
          </Button>
        </StyledDialogActions>
      </DialogBox>
    </>
  );
}
